import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import { FOOD_PARTNER_ORDER_PATH } from '../../core/constants';

export const getFoodPartnerOrderHistoryAction = createAsyncThunk(
    'inventory/getFoodPartnerOrderHistoryAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ FOOD_PARTNER_ORDER_PATH }/history${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getFoodPartnerOrderHistorySlice = createSlice({
    name: 'getFoodPartnerOrderHistorySlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateFoodPartnerOrderHistory() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getFoodPartnerOrderHistoryAction.pending, () => STATE__API__STARTED);
        builder.addCase(getFoodPartnerOrderHistoryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getFoodPartnerOrderHistoryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateFoodPartnerOrderHistory } = getFoodPartnerOrderHistorySlice.actions;
export const getFoodPartnerOrderHistoryState = (state) => state.inventory.getFoodPartnerOrderHistory;
export default getFoodPartnerOrderHistorySlice.reducer;
